export default {
  common_button_back: 'Bakåt',
  common_button_cancel: 'Avbryt',
  common_button_next: 'Nästa',
  common_button_no: 'Nej',
  common_button_ok: 'OK',
  common_button_reset: 'Återställa',
  common_button_skip: 'Hoppa över',
  common_button_yes: 'Ja',
  common_deactivated_message:
    'Denna kiosk har aktiverats på en annan iPad och är således inte längre aktiv på den här. Vänligen logga in igen. Tack!',
  common_deactivated_title: 'Kiosk avaktiveras på denna iPad',
  common_enterEmail_email: 'Ange din e-postadress (arbete)',
  common_enterEmail_title: 'Din e-postadress',
  common_error_message_cameraNotAllowed: 'Kameraåtkomst måste tillåtas för att använda den här funktionen.',
  common_error_message_ForbiddenException: 'Otillräckliga rättigheter',
  common_error_message_incorrectEmail: 'Ange en korrekt e-postadress',
  common_error_message_invalidCredentials: 'Hoppsan! Användarnamnet och/eller lösenordet är inkorrekt. Försök igen',
  common_error_message_invalidMobile: 'Vänligen ange ett giltigt mobiltelefonnummer',
  common_error_message_missingField: 'Obligatoriskt fält',
  common_error_message_noInternetConnection: 'Internetanslutningen är förlorad. Försök igen.',
  common_error_message_unauthorizedAccess: 'Obehörig åtkomst',
  common_error_message_webServiceWrongConnection: 'Ett fel uppstod under dataöverföringen. Försök igen',
  common_error_title: 'Fel',
  common_expired_message:
    'Utvärderingsperioden har löpt ut eller kreditkorten som vi har på fil har slutat fungera. Vänligen uppgradera för att återaktivera kontot. Kontakta sales@proxyclick.com om du har några frågor. Tack!',
  common_expired_title: 'Konto utgånget',
  common_onboarding_login_button: 'Logga in',
  common_onboarding_message1: 'Proxyclick hjälper dig att välkomna dina besökare på exakt det sättet du vill.',
  common_onboarding_message2:
    'Varumärkesanpassa din incheckning och dina etiketter och be dina besökare att svara på endast de frågor som gäller för dem.',
  common_onboarding_message3: 'Värdar meddelas när deras gäster anländer och kan svara omedelbart.',
  common_onboarding_message4:
    'Skydda dina anläggningar och säkerställ överensstämmelse genom akutlistor, övervakningslistor, NDAs, sekretessregler...',
  common_onboarding_message5: 'Proxyclick gör det svåra arbetet så du kan välkomna dina besökare med ett leende.',
  common_placeholder_optional: 'Valfritt',
  common_setup_activationCode_activate_button: 'Aktivera',
  common_setup_activationCode_code: 'Enter your activation code',
  common_setup_activationCode_code_placeholder: 'T.ex. YSSFG-CVWVR-JFRWX-HSNMK',
  common_setup_activationCode_error_invalidCode: 'Ogiltig aktiveringskod',
  common_setup_activationCode_footer: 'Activation code is handy for SSO admins or for local guards. Learn More.',
  common_setup_activationCode_title: 'Aktivera kiosk med unik kod',
  common_setup_device_footer: 'Anslut till Proxyclick-webbappen för att skapa en ny kiosk',
  common_setup_device_locked_content:
    'Denna kiosk används redan på en annan iPad. Om du ställer in den på denna iPad kommer den att inaktiveras på den andra. Är du säker på att du vill ställa in kiosken på denna iPad?',
  common_setup_device_locked_continue_button: 'Ställ in den här kiosken',
  common_setup_device_locked_title: 'Kiosken används redan',
  common_setup_device_multiTenants: 'Multiföretag',
  common_setup_device_title: 'Välj kiosk',
  common_setup_loading_footer: 'Anslut till Proxyclick-webbappen för att anpassa din kiosk',
  common_setup_loading_message: 'Konfigurerar...',
  common_setup_loading_title: 'Din kiosk ställs in...',
  common_setup_location_footer: 'Anslut till Proxyclick-webbappen för att skapa en ny plats',
  common_setup_location_kiosk: 'kiosk',
  common_setup_location_kiosks: 'kiosker',
  common_setup_location_title: 'Välj plats',
  common_setup_login_activationCode_button: 'Aktivera med unik kod?',
  common_setup_login_email: 'E-postadress',
  common_setup_login_forgotPassword_button: 'Hur du glömt lösenordet?',
  common_setup_login_password: 'Lösenord',
  common_setup_login_title: 'Logga in med ditt Proxyclick-konto',
  common_setup_ready_header: 'Är du redo att använda denna iPad som din {0}-kiosk?',
  common_setup_ready_message: 'Det tar bara en minut att konfigurera kiosken innan den är igång',
  common_setup_ready_setup_button: 'Ställ in',
  common_setup_ready_title: 'Hej {0}',
  common_signup_company: 'Företag',
  common_signup_email: 'E-postadress',
  common_signup_error_name: 'Ange för- och efternamn',
  common_signup_loading_message1:
    'Du kan anpassa din kiosk genom att ansluta till Proxyclick-webbappen. Vi har precis skickat ett e-postmeddelande till dig med all information.',
  common_signup_loading_message2:
    'Via webbsidan kan du ställa in din skrivare för att skriva ut brickor vid incheckning.',
  common_signup_loading_message3: 'Du kan även aktivera meddelanden som skickas till värden vid incheckning.',
  common_signup_loading_message4: 'Och anpassa din kiosk med egna färger och välkomstbild.',
  common_signup_loading_title: 'Skapa ditt konto…',
  common_signup_name: 'Namn',
  common_signup_name_placeholder: 'Förnamn Efternamn',
  common_signup_password: 'Lösenord',
  common_signup_title: 'Välkommen till Proxyclick',
  common_signup_tryFree_button: 'Skicka',
  common_timeout_content: 'Tryck för att avbryta',
  common_timeout_title: 'Tillbaka till startsidan',
  common_tooltip_disable_button: 'Inaktivera alla tips',
  common_tooltip_gotIt_button: 'Jag fattar',
  dm_delivery_confirmation_knownRecipient: '{{Host_Name}} har informerats om att du har levererat ett paket',
  dm_delivery_confirmation_title: 'Tack!',
  dm_delivery_confirmation_unknownRecipient:
    'Ett meddelande har skickats till {{Company_Name}} för att informera att du har levererat ett paket för dem',
  dm_delivery_recipient_name: 'Vem är det här paketet för?',
  dm_delivery_recipient_unknown_button: 'Jag vet inte',
  em_multiTenant_alreadyRegistered_button: 'Tap here if you are an employee or have received a QR code to check in',
  em_multiTenant_notRegistered_button: 'Tap here to check in manually',
  vm_checkin_approval_confirmation_unregistered_message:
    'We are unable to check you in at this time. Please contact your host or reach out the reception for assistance.',
  vm_checkin_approval_confirmation_unregistered_title: 'Welcome {{Visitor_FirstName}} {{Visitor_LastName}}',
  vm_checkin_approval_notapproved_message:
    'We are unable to finalize your check-in at this time. Please contact your host or reach out to reception for assistance.',
  vm_checkin_approval_notapproved_title: 'Dear {{Visitor_FirstName}} {{Visitor_LastName}}',
  vm_checkin_confirmation_header_withoutPrint: 'Du är registrerad!',
  vm_checkin_confirmation_header_withPrint: 'Din bricka skrivs ut',
  vm_checkin_confirmation_message: 'Slå dig ner, {{Host_FirstName}} kommer om en liten stund',
  vm_checkin_confirmation_takeBackID: "Please don't forget your ID",
  vm_checkin_confirmation_title: 'Tack!',
  vm_checkin_details_companyName: 'Företag',
  vm_checkin_details_email: 'E-postadress',
  vm_checkin_details_firstname: 'Förnamn',
  vm_checkin_details_lastname: 'Efternamn',
  vm_checkin_details_title: 'Please enter your details',
  vm_checkin_error_message_unableToCheckIn: 'Ett fel uppstod vid incheckningen. Kontakta receptionen',
  vm_checkin_flow_company: 'Företag',
  vm_checkin_flow_duration: 'Besök varaktighet',
  vm_checkin_flow_email: 'E-postadress',
  vm_checkin_flow_error_message_imageNotAvailable:
    'Hoppsan, bilden är inte tillgänglig för tillfället (problem med internetanslutningen)',
  vm_checkin_flow_licensePlate: 'Registreringsskylt',
  vm_checkin_flow_mobile: 'Vänligen ange ditt mobilnummer',
  vm_checkin_flow_mobile_info:
    'Detta kommer att användas för att få kontakt med dig vid en nödsituation medan du är på anläggningen',
  vm_checkin_flow_tooltip_content:
    'Fråga dina besökare allt du behöver för att förbättra deras upplevelse eller för att göra incheckningen säkrare. Du kan ändra flödet av frågor i enlighet med besökarnas svar. Frågorna som du ser är bara exempel för demoversionen.',
  vm_checkin_flow_tooltip_title: 'Smarta frågor',
  vm_checkin_host_enterFullName: 'Ange din värds fullständiga namn',
  vm_checkin_host_name: 'Vem besöker du?',
  vm_checkin_host_notListed_block:
    'Prata med receptionisten om du inte känner din värd eller om du inte hittar honom/henne på listan',
  vm_checkin_host_notListed_continue: 'Inte på listan',
  vm_checkin_host_tooltip_content:
    'Skriv ditt namn här så skickar vi e-postmeddelandet som dina anställda kommer att få när deras besökare anländer.',
  vm_checkin_host_tooltip_title: 'Meddelande om besökarens ankomst',
  vm_checkin_host_unknown_button: 'Jag vet inte',
  vm_checkin_idScan_aila_footer: 'This screen is skipped when you use the recommended hardware ({0})',
  vm_checkin_idScan_aila_header: 'Please scan your ID',
  vm_checkin_idScan_aila_learnMore: 'Lär dig mer',
  vm_checkin_idScan_aila_scan_button: 'Scan ID',
  vm_checkin_idScan_back_picture_header_aila: 'Place your ID in the holder so the back faces the camera.',
  vm_checkin_idScan_back_picture_header_noAila: 'Position the back of your ID entirely inside the frame.',
  vm_checkin_idScan_back_picture_take_button: 'Scan back',
  vm_checkin_idScan_cancel_message: 'Check-in will be cancelled and you will return to home screen',
  vm_checkin_idScan_cancel_title: 'Warning',
  vm_checkin_idScan_disclaimer_start_button: "Let's get started",
  vm_checkin_idScan_disclaimer_text:
    'As part of our security policy, we need to verify your identity using your ID. \n\nWe value your privacy, so we will not store the picture of your ID. Reception officers are available to help if you have any questions.',
  vm_checkin_idScan_editName_title: 'Please fill in your first and last name',
  vm_checkin_idScan_front_picture_header_aila: 'Place your ID in the holder so the front faces the camera.',
  vm_checkin_idScan_front_picture_header_noAila: 'Position your ID entirely inside the frame.',
  vm_checkin_idScan_front_picture_take_button: 'Scan front',
  vm_checkin_idScan_match_check: 'Comparing the two pictures',
  vm_checkin_idScan_match_confirm_button: 'Confirm',
  vm_checkin_idScan_match_error_default_header: 'Sorry, something went wrong.',
  vm_checkin_idScan_match_error_default_message: 'Ask a receptionist for help or try again.',
  vm_checkin_idScan_match_error_idExpired_header: 'Sorry, your ID seems to have expired.',
  vm_checkin_idScan_match_error_idExpired_message: 'Ask a receptionist for help or try again.',
  vm_checkin_idScan_match_error_idNoFace_header: 'Sorry, we could not identify a face on your ID.',
  vm_checkin_idScan_match_error_idNoFace_message: 'Ask a receptionist for help or try again.',
  vm_checkin_idScan_match_error_pictureNoFace_header: 'Sorry, we could not identify a face on the picture you took.',
  vm_checkin_idScan_match_error_pictureNoFace_message: 'Ask a receptionist for help or try again.',
  vm_checkin_idScan_region_0: ' United States',
  vm_checkin_idScan_region_1: ' Canada',
  vm_checkin_idScan_region_2: 'South America',
  vm_checkin_idScan_region_3: ' Europe',
  vm_checkin_idScan_region_4: ' Australia',
  vm_checkin_idScan_region_5: ' Asia',
  vm_checkin_idScan_region_6: ' General Documents',
  vm_checkin_idScan_region_7: ' Africa',
  vm_checkin_idScan_region_header: 'What region does your ID come from?',
  vm_checkin_instructions_agreeTerms_button: 'Acceptera',
  vm_checkin_instructions_clearSignature_button: 'Rensa',
  vm_checkin_instructions_sendCopy_button: 'Skicka en kopia till mig via e-post',
  vm_checkin_instructions_sendCopyTo_button: 'En kopia kommer att skickas till {0} (Ändra)',
  vm_checkin_instructions_sign: 'Signera här med fingret',
  vm_checkin_instructions_tooltip_content:
    'Få dina gäster att acceptera dina besöksregler med en enkel tryckning eller signatur. Du kan anpassa dina villkor beroende på typ av besökare som checkar in. Anpassa den här funktionen och flera andra på Proxyclick-instrumentpanelen.',
  vm_checkin_instructions_tooltip_title: 'Klappat och klart',
  vm_checkin_method_name: 'Hej, vad heter du?',
  vm_checkin_method_name_enterFullName: 'Ange ditt fullständiga namn',
  vm_checkin_method_name_invitationQuestion: 'Did you receive an invitation with a QR-code?',
  vm_checkin_method_name_notRegistered_block: 'Inte på listan? Kolla med receptionen',
  vm_checkin_method_name_notRegistered_continue: 'Inte på listan?',
  vm_checkin_method_tooltip_content:
    'Checka in som "Justin Diaz" för att se hur återvändande eller förregistrerade besökare identifieras. \n\nEller skriv ett slumpmässigt namn för att se hur oväntade besökare tas om hand.',
  vm_checkin_method_tooltip_title: 'Igenkänning av besökare',
  vm_checkin_picture_auto_countDown: ' ',
  vm_checkin_picture_auto_lookCamera: 'Please look at the camera, we will take your visitor picture',
  vm_checkin_picture_auto_pictureTaken: 'Picture taken',
  vm_checkin_picture_auto_stayStill: 'Remain still',
  vm_checkin_picture_take_button: 'Ta en bild',
  vm_checkin_picture_title: 'Nu tar vi din bild!',
  vm_checkin_picture_tooltip_content:
    'Du kan skräddarsy kiosken som du vill och enkelt lägga till eller ta bort funktioner, såsom att ta besökarbilder eller utskrift av brickor.',
  vm_checkin_picture_tooltip_title: 'Valfria funktioner',
  vm_checkin_qrcode_no_checkin_allowed: 'Checkin not allowed. Please contact the reception for assistance.',
  vm_checkin_returning_email: 'Hej, vad är din e-postadress?',
  vm_checkin_returning_email_notRegistered:
    'We could not find a scheduled visit linked to your email address. Please check with reception or try again with a different email address.',
  vm_checkin_saveInfo_email: 'Spara min information för att underlätta min nästa incheckning',
  vm_checkin_saveInfo_email_placeholder: 'Ange din e-postadress',
  vm_checkin_saveInfo_title: 'Ange din e-postadress',
  vm_checkin_summary_agreementAlreadySigned: 'Agreement already signed',
  vm_checkin_summary_checkin_button: 'Checka in',
  vm_checkin_summary_countDown: 'You will be checked in after',
  vm_checkin_summary_editDetails_button: 'Redigera information',
  vm_checkin_summary_groupStats: '{0} av {1} personer är redan där',
  vm_checkin_summary_meetingTime: 'Möte kl {0}',
  vm_checkin_summary_reviewDetails_button: 'Granska min besöksinformation',
  vm_checkin_summary_sendPass_button: 'Skicka ett pass till min smartphone för framtida besök',
  vm_checkin_summary_sendPassTo_button: 'Ett permanent pass kommer att skickas till {0} (Ändra)',
  vm_checkin_summary_takeNewPicture_button: 'Ta en ny bild',
  vm_checkin_summary_title: 'Ditt besök på {{Company_Name}}',
  vm_checkin_summary_visiting: 'Besöker {0}',
  vm_checkin_video_duration: 'Duration',
  vm_checkin_video_subtitle: 'Watch the full video to continue your check-in.',
  vm_checkin_welcome_firstTime: 'Välkommen {{Visitor_FirstName}}!',
  vm_checkin_welcome_lastVisit_date: 'Ditt senaste besök var {0}',
  vm_checkin_welcome_lastVisit_today: 'Ditt senaste besök var idag',
  vm_checkin_welcome_lastVisit_yesterday: 'Ditt senaste besök var igår',
  vm_checkin_welcome_returning: 'Välkommen tillbaka {{Visitor_FirstName}}!',
  vm_checkout_confirmation_header: 'Adjö {{Visitor_FirstName}}!',
  vm_checkout_confirmation_message: 'Du har checkats ut. Vi hoppas att du har haft ett trevligt besök.',
  vm_checkout_confirmation_title: 'Tack för ditt besök!',
  vm_checkout_method_name: 'Ange ditt namn för att kolla in',
  vm_checkout_method_name_notFound: 'Hittades inte',
  vm_checkout_method_title: 'Checka ut',
  vm_identification_id_button: 'Skanna ditt ID',
  vm_identification_qrCode_button: 'Skanna din inbjudan/pass',
  vm_infopack_confirmation: 'Tack! \nVi har skickat information till {0}.',
  vm_infopack_email: 'Ange din e-postadress så skickar vi information om Proxyclick',
  vm_infopack_likeCheckIn: 'Gillade du denna incheckning? Tryck här för att läsa mer',
  vm_infopack_likeProcess: 'Gillade du denna process? Tryck här för att läsa mer',
  vm_infopack_send_button: 'Skicka information till mig',
  vm_multiTenant_title: 'Välkommen, vilket företag besöker du?',
  vm_product_footer_learnMore: 'Lär dig mer',
  vm_product_footer_noPartner: 'Du använder Proxyclick Välkommen',
  vm_product_footer_partner: 'Du använder Proxyclick Välkommen, presenterat av {0}',
  vm_qrCode_help: 'Håll koden 10-15 cm från kameran',
  vm_qrCode_not_recognized: 'Kan inte identifiera koden',
  vm_qrCode_title: 'Skanna din bricka eller Passbook-kod',
  vm_signup_defaultInstruction_content:
    '<p style="text-align: center;"><img class="instruction-icon" src="http://static.proxyclick.com/_/app/img/safetyIcons/terms/icon-wearbadge.png" width="50"/><img class="instruction-icon" src="http://static.proxyclick.com/_/app/img/safetyIcons/terms/icon-assemblypoint.png" width="50"/><img class="instruction-icon" src="http://static.proxyclick.com/_/app/img/safetyIcons/terms/icon-nopic.png" width="50"/><img class="instruction-icon" src="http://static.proxyclick.com/_/app/img/safetyIcons/terms/icon-nosmoke.png" width="50"/><br/></p><h1>BESÖKSINSTRUKTIONER OCH SEKRETESSAVTAL</h1>Välkommen! Vi är glada att ha dig som gäst för {{Company_Name}} på våra faciliteter.<h2>Hälso- och säkerhetsanvisningar</h2><p>Din personliga säkerhet är vår angelägenhet under hela ditt besök. Därför begär vi att du går med följande:</p><ul><li><b>Åtkomst till lokalerna</b>tillåts enbart i närvaro av en anställd från {{Company_Name}}</li><li>Besöksbricka<b></b>måste bäras hela tiden och lämnas tillbaka till receptionen vid avfärd</li><li>Om en <b>nödsituation</b> uppstår måste alla besökare omedelbart lämna lokalerna, via närmaste nödutgång, och rapportera till angiven samlingsplats</li><li>Besökare är <b>förbjudna att ta bilder</b>(fotografier och videofilmer) inne i lokalerna eller runt de omgivande faciliteterna</li><li><b>Rökning är strikt förbjudet</b>inne i byggnaden</li></ul><h2>Sekretessavtal</h2><p>Under ditt besök till {{Company_Name}}:s faciliteter kommer du eventuellt att ta del av och/eller visas skyddad eller konfidentiell information (inklusive, och utan begränsningar, information som har att göra med teknik, processer, utrustning, ritningar och specifikationer) som inte är känd för allmänheten (nedan gemensamt kallad &#34;Konfidentiell information&#34;).</p><p>Med hänsyn till ditt tillstånd att besöka {{Company_Name}}:s faciliteter och ditt tillmötesgående under ditt besök, godkänner du Jag accepterar att jag inte, antingen;</p><p>(a) Avslöjar eller gör tillgängligt för andra någon Konfidentiell information som har avslöjats för dig under detta och påföljande besök; eller</p><p>(b) Använder eller hjälper andra att på något sätt använda eller utveckla någon konfidentiell information.</p><p>(c) Använder kamera eller videoteknik för att avslöja konfidentiell information.</p><p>Genom att skriva in dig på faciliteterna bekräftar du och förstår Hälso- och säkerhetsanvisningarna samt sekretessavtalet.</p>',
  vm_signup_defaultInstruction_name: 'Instruktioner som alla besökare måste signera',
  vm_signup_defaultInstruction_title: 'Läs och signera nedan',
  vm_vaccine_certification_accessDenied_button: 'Okay',
  vm_vaccine_certification_accessDenied_message:
    "Sorry you don't meet the vaccination requirements to enter the premisses",
  vm_vaccine_certification_accessDenied_title: 'Access has been denied',
  vm_vaccine_certification_declare_question_title:
    'Dear visitor, please declare whether you have a valid COVID vaccine certificate or a COVID test with a negative result',
  vm_vaccine_certification_intro_question_title: 'Dear visitor, do you have an EU COVID Vaccine Certificate?',
  vm_vaccine_certification_scanner_donthaveaqrcode: "I don't have a QR code",
  vm_vaccine_certification_scanner_subtitle:
    'Make sure that your QR code is enlarged and the brightness of your mobile phone is on maximum.',
  vm_vaccine_certification_scanner_title: 'Please present the QR code of your EU COVID certificate to the camera',
  vm_welcome_changeLanguage_button: 'Change language',
  vm_welcome_checkin_button: 'Checka in',
  vm_welcome_checkout_button: 'Checka ut',
  vm_welcome_delivery_button: 'Leverans',
  vm_welcome_hello_line1: 'Välkommen',
  vm_welcome_hello_line2: 'till {{Company_Name}}',
  vm_welcome_qrCode_checkedIn: "Welcome {0}, don't forget to check out before leaving",
  vm_welcome_qrCode_checkedOut: 'Thank you for visiting, {0}!',
  vm_welcome_qrCode_notRecognized: 'This QR code is not recognized. Please try again.',
  vm_welcome_qrCode_scan: 'Pre-registered Visitors: hold your QR code up to the camera for check-in or out',
  vm_welcome_qrCode_show: 'Employees: scan this QR code with Proovr to check in or check out',
  vm_welcome_qrCode_wrongCompany: 'Your QR code is invalid for this location.',
  vm_welcome_returning_button: 'Jag har varit här förut',
  vm_welcome_title: 'Välkommen till {{Company_Name}}',
  vm_welcome_tooltip_content:
    'Logga in på Proxyclick-webbappen för att anpassa din kiosk. Vi har precis skickat ett e-postmeddelande med anvisningar. I webbappen kan du ladda upp logo, bakgrundsbild och välja färg så att din kiosk reflekterar ditt varumärkes identitet.',
  vm_welcome_tooltip_title: 'Gör din egen',
  vm_welcome_touchless_employee_qrCode_show: 'Scan this QR code with Proovr to check in as an employee',
  vm_welcome_touchless_qrCode_show: 'Unregistered Visitors: Scan this QR code for touchless check-in',
  vm_welcome_touchless_unexpected_and_employee_qrCode_show:
    'Scan this QR code with Proovr (employees) or your phone (visitors) to check in',
  vm_welcome_touchless_unexpected_qrCode_show: 'Scan this QR code with your phone to check in as a visitor',
  common_or: 'eller',
};
